import { css as _css } from "@emotion/react";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ArcAdminLogo } from '@arc/frontend/ui-assets';
import { su, theme } from '@arc/frontend/ui-theme';
import { useAuthSafe, useRedirectFromLogin } from '@arc/frontend/util-auth';
import { LoginForm } from './LoginForm';
function VersionDisplay() {
  const buildDate = document.lastModified;
  const appTag = process.env.NX_PUBLIC_RELEASE_VERSION || process.env.NX_PUBLIC_ENVIRONMENT || 'dev';
  const appVersion = process.env.NX_PUBLIC_APP_VERSION ?? 'local';
  return <div css={[su.textXs, {
    position: 'fixed',
    display: 'flex',
    gap: '0.25rem',
    right: '0.5rem',
    bottom: '0.5rem',
    color: theme.colors.action.disabledBackground,
    '&:hover': {
      color: theme.colors.text.primary
    }
  }, process.env.NODE_ENV === "production" ? "" : ";label:VersionDisplay;"]}>
			{appTag ? <div>{appTag}</div> : null}
			{appVersion ? <div>({appVersion.slice(0, 7)})</div> : null}
			<div>{buildDate}</div>
		</div>;
}
function useRedirectIfAlreadyLoggedIn() {
  const {
    user,
    status
  } = useAuthSafe();
  const redirectFromLogin = useRedirectFromLogin(user);
  useEffect(() => {
    if (user && status === 'logged-in') {
      setTimeout(() => redirectFromLogin(), 60);
    }
  }, [user, status, redirectFromLogin]);
}
const LOGO_SIZE = 300;
export default function LoginPage() {
  const {
    t
  } = useTranslation(['common', 'login']);
  useRedirectIfAlreadyLoggedIn();
  useEffect(() => {
    document.title = `${t('appName')}: ${t('login:login')}`;
  }, [t]);
  return <div css={
  /*#__PURE__*/
  // Take up full screen and center content
  _css({
    alignItems: 'center',
    justifyContent: 'center',
    width: '100vw',
    height: '100vh',
    display: 'grid',
    gridTemplateRows: 'repeat(1, minmax(0, 1fr))',
    gridTemplateColumns: `${LOGO_SIZE}px 13rem`,
    columnGap: '6rem',
    backgroundImage: `linear-gradient(#ffffff, ${theme.colors.background.loginScreen})`
  }, process.env.NODE_ENV === "production" ? "" : ";label:LoginPage;")}>
			<ArcAdminLogo width={LOGO_SIZE} height={LOGO_SIZE * 0.57} title="ARC Admin" color={theme.colors.background.header} />
			<LoginForm />
			<VersionDisplay />
		</div>;
}